// extracted by mini-css-extract-plugin
module.exports = {"header":"AllChatsOverlay_header__ofCQq","footer":"AllChatsOverlay_footer___DvQ3","closeIcon":"AllChatsOverlay_closeIcon__4KmwK","offCanvas":"AllChatsOverlay_offCanvas__6W63H"};